/*!
 * ignore
 */

module.exports = function() {};
